// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 767px) {
  .modal-body {
    padding-right: 5%;
    padding-left: 5%;
  }
}

:host ::ng-deep .checkbox {
  padding-left: 15px;
}

.payment-icon .institution-logo {
  height: 30px;
}
.payment-icon .credit-card-img {
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/U2026_netpromoterscore/U2026_netpromoterscore-modal/U2026_netpromoterscore-form/U2026_netpromoterscore-form.component.scss"],"names":[],"mappings":"AAII;EADJ;IAEQ,iBAAA;IACA,gBAAA;EAFN;AACF;;AAMI;EACI,kBAAA;AAHR;;AAQI;EACI,YAAA;AALR;AAOI;EACI,YAAA;AALR","sourcesContent":["@import \"../../../U2000_style/U2000_style-mixins\";\n@import \"../../../U2000_style/U2000_style-variables\";\n\n.modal-body {\n    @media (min-width: $screen-xs-top) {\n        padding-right: 5%;\n        padding-left: 5%;\n    }\n}\n\n:host {\n    ::ng-deep .checkbox {\n        padding-left: 15px;\n    }\n}\n\n.payment-icon {\n    .institution-logo {\n        height: 30px;\n    }\n    .credit-card-img {\n        height: 30px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
